// src/utils/validators.ts
export function validateNombre(v: string): string {
  return v.trim().length < 3 ? "Debe tener al menos 3 caracteres" : "";
}

export function validateApellidos(v: string): string {
  return v.trim().length < 3 ? "Debe tener al menos 3 caracteres" : "";
}

export function validateTelefono(v: string): string {
  if (v.length < 9) return "El teléfono debe tener al menos 9 caracteres";
  if (v.length > 10) return "Máx 10 caracteres";
  return "";
}

export function validatePassword(v: string): string {
  const passRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
  return passRegex.test(v) ? "" : "Debe tener mayúscula, minúscula, número y 6+ caracteres";
}

export function validateCodigoPostal(v: string): string {
  const regex = /^40\d{3}$/;
  return regex.test(v.trim()) ? "" : "El código postal debe pertenecer a la provincia de Segovia";
}

export function validateDni(value: string): string {
  const regex = /^(\d{8}[A-Z]|X\d{7}[A-Z])$/;
  return regex.test(value.trim())
    ? ""
    : "DNI inválido: debe tener 8 números y una letra mayúscula o X + 7 números + letra mayúscula";
}
